import { useCallback, useEffect, useState } from 'react';
import { getCameraPreviewFrame } from '../services/cameras';

/**
 * Единый источник preview/last-frame камеры для Zone Editor и обоих
 * Change Request Detail (B1: один reusable слой, а не три локальных
 * workaround'а).
 *
 * phase:
 *  - `loading` — запрос идёт;
 *  - `ready`   — есть url original-кадра;
 *  - `empty`   — backend ответил, но кадра в каноническом пространстве нет;
 *  - `error`   — запрос упал. Это не «кадров нет»: утверждать отсутствие
 *                кадров, когда backend их имеет, нельзя (ТЗ B1).
 */
export const useCameraPreviewFrame = (cameraId) => {
  const [state, setState] = useState({ phase: cameraId ? 'loading' : 'empty', url: '', error: null });
  const [attempt, setAttempt] = useState(0);

  useEffect(() => {
    if (!cameraId) {
      setState({ phase: 'empty', url: '', error: null });
      return undefined;
    }

    let cancelled = false;
    setState({ phase: 'loading', url: '', error: null });

    getCameraPreviewFrame(cameraId)
      .then((preview) => {
        if (cancelled) return;
        const url = preview?.url || '';
        setState({ phase: url ? 'ready' : 'empty', url, error: null });
      })
      .catch((error) => {
        if (cancelled) return;
        setState({ phase: 'error', url: '', error });
      });

    return () => { cancelled = true; };
  }, [cameraId, attempt]);

  const reload = useCallback(() => setAttempt((value) => value + 1), []);

  return { phase: state.phase, url: state.url, error: state.error, reload };
};

export default useCameraPreviewFrame;
